import SoccerJersey from "soccer-jersey";
import constants from "./constants";
import fplService from "./utils/fplService";
import soccerPitch from "../shared/svg/soccer-field.svg";

const WidgetTeamLineUp = ({ team, ...rest }) => {
  const allPlayers = fplService.getPlayers();

  const teams = fplService.getTeams().map((team) => {
    const { short_name } = team;
    const jersey = SoccerJersey.draw(constants.jerseyDesigns[short_name]);
    return { ...team, jersey };
  });

  const players = team.map((player) => allPlayers[player]);

  const soccerFieldCell = (key, player = null) => {
    return (
      <div className="text-center" 
      key={key} style={{ flex: player ? 2 : 1 }}>
        {player ? (
          <div
            style={{
              display: "inline-block",
              height: "100%",
              width: "4rem",
              overflow: "hidden",
              textAlign: "center",
            }}
          >
            <img
              src={teams[player.team - 1].jersey}
              alt=""
              style={{
                display: "inline-block",
                width: "100%",
                maxWidth: "3rem",
              }}
            />
            <div
              className="block text-xs font-bold bg-black text-white mr-0.5"
              style={{ fontSize: 9 }}
            >
              {" "}
              {player.web_name}
            </div>
            <div
              className="block text-xs bg-white text-black bg-opacity-50 mr-0.5"
              style={{ fontSize: 8 }}
            >
              {teams[player.team - 1].short_name}
            </div>
          </div>
        ) : (
          "-"
        )}
      </div>
    );
  };

  const layoutRow = (players) =>
    players.map((player, index) => soccerFieldCell(index, player));

  return (
    <div className="py-12 lg:px-6 w-full h-full">
      <div
        className="w-full h-full"
        style={{
          height: 420,
          backgroundImage: `url(${soccerPitch})`,
          backgroundSize: "100% 100%",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="relative -top-8 h-full w-full  flex flex-col "
          style={{ height: "100%" }}
        >
          <div className="flex-grow inline-flex flex-row justify-evenly">
            {layoutRow([players[0]])}
          </div>{" "}
          <div className="pt-2  flex-grow inline-flex  flex-row justify-evenly">
            {layoutRow([players[1], players[2], players[3],players[7]])}
          </div>{" "}
          <div className="pt-2  flex-grow inline-flex  flex-row justify-evenly">
            {layoutRow([players[4], players[5], players[6], players[8]])}
          </div>{" "}
          <div className="pt-2  flex-grow inline-flex  flex-row justify-evenly">
            {layoutRow([players[9], players[10]])}
          </div>{" "}
          <div className="pt-2 flex-grow  bg-gray-100  inline-flex flex-row justify-evenly">
            {layoutRow([players[11], players[12], players[13], players[14]])}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetTeamLineUp;
